import  axiosClient  from "../Network/apiClient"
const VisitService = {

    getVisits: (season, plot) => {
        return axiosClient.get('/visits?'+ (season ? "season=" + season : '') + (plot ? '&plot=' + plot : ''));
    },
    getSiblings: (plot) => {
        return axiosClient.get('/visits/siblings?plot=' + plot);
    },
    getObjectInfo: (objectId, timeStart) => {
        return axiosClient.get(`/visits/objectinfo?objectid=${objectId}&timestart=${timeStart}`);
    },
    getFeatures: (filter) => {
        return axiosClient.get('/visits/features', {params: filter});
    },
    getFeatureDetails: (id) => {
        return axiosClient.get(`/visits/features/${id}`);
    },
    getVisit: (id) => {
        return axiosClient.get('/visits/' + id);
    },
    updateVisit: (visit) =>  {
        if (visit.id > 0)
            return axiosClient.put(`/visits/${visit.id}`,JSON.stringify(visit));
        else
            return axiosClient.post('visits', JSON.stringify(visit));
    },
    updateStatus: (visit,status) =>  {
        return axiosClient.put(`/visits/${visit.id}/status/${status}`);
    },
    deleteVisit: (visit) =>  {
        return axiosClient.delete(`/visits/${visit.id}`);
    },

}

export default VisitService
